import React from "react";
import { Table, Alert } from "antd";
import PropTypes from "prop-types";

import { formatDate } from "../../helpers/date";
import { toCents, formatCents } from "../../helpers/codOffset";

// Charges the server proposes to offset against this merchant's COD (PD-2333). The server decides
// who is eligible: the parent only renders this when the report carries codOffset.
const CodOffsetPanel = ({ codOffset, selectedIds, onChange, codAmount, summary }) => {
  const columns = [
    { title: "Tracking Number", dataIndex: "consignNo", key: "consignNo" },
    { title: "Charge Type", dataIndex: "chargeType", key: "chargeType" },
    {
      title: "Recognition Date",
      dataIndex: "recognitionDate",
      key: "recognitionDate",
      render: (date) => (date ? formatDate(date) : "-"),
    },
    {
      title: "Amount (RM)",
      dataIndex: "amount",
      key: "amount",
      align: "right",
      // Negative charges are credits: shown in red with a minus sign, and counted in the total.
      render: (amount) => (
        <span style={toCents(amount) < 0 ? { color: "red" } : undefined}>
          {toCents(amount) < 0 ? "-" : ""}RM {formatCents(Math.abs(toCents(amount)))}
        </span>
      ),
    },
  ];

  return (
    <div className="mb-2">
      <h4>
        <strong>COD offset: unbilled charges for {codOffset.billingPeriod}</strong>
      </h4>

      {!codOffset.exact && (
        <Alert
          className="mb-2"
          type="warning"
          showIcon
          message="This suggestion may not be the highest possible total."
        />
      )}

      <Table
        size="small"
        rowKey="id"
        pagination={{ pageSize: 20, size: "small", hideOnSinglePage: true, showSizeChanger: false }}
        columns={columns}
        dataSource={codOffset.charges}
        rowSelection={{ selectedRowKeys: selectedIds, onChange }}
      />

      <div className="mt-2">
        <div>COD amount: RM {formatCents(toCents(codAmount))}</div>
        <div>
          Selected offset total: <strong>RM {formatCents(summary.offsetCents)}</strong>
        </div>
        <div>
          Payout after offset: <strong>RM {formatCents(summary.remainingCents)}</strong>
        </div>
        {summary.blockReason && <div style={{ color: "red" }}>{summary.blockReason}</div>}
      </div>
    </div>
  );
};

CodOffsetPanel.propTypes = {
  codOffset: PropTypes.shape({
    billingPeriod: PropTypes.string,
    charges: PropTypes.arrayOf(PropTypes.object).isRequired,
    exact: PropTypes.bool,
  }).isRequired,
  selectedIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
  codAmount: PropTypes.number.isRequired,
  summary: PropTypes.shape({
    offsetCents: PropTypes.number,
    remainingCents: PropTypes.number,
    blockReason: PropTypes.string,
  }).isRequired,
};

export default CodOffsetPanel;
